import { useState } from 'react';
import { Bookmark, X, Plus } from 'lucide-react';
import { toast } from 'sonner';

export function SavedFilters({ storageKey, getCurrent, onApply }) {
  const [saved, setSaved] = useState(() => { try { return JSON.parse(localStorage.getItem(storageKey)) || []; } catch { return []; } });
  const persist = (list) => { setSaved(list); localStorage.setItem(storageKey, JSON.stringify(list)); };
  const save = () => {
    const name = window.prompt('Name this filter set:');
    if (!name) return;
    persist([...saved.filter((s) => s.name !== name), { name, snapshot: getCurrent() }]);
    toast.success(`Saved filter "${name}"`);
  };
  return (
    <div className="flex items-center gap-1.5 flex-wrap" data-testid="saved-filters">
      <Bookmark className="w-3 h-3 text-slate-400" />
      <span className="text-[10px] uppercase tracking-wider text-slate-400 font-semibold">Saved</span>
      {saved.map((s) => (
        <span key={s.name} className="flex items-center gap-1 text-[11px] pl-2 pr-1 py-0.5 rounded-full border border-violet-200 bg-violet-50 text-violet-700">
          <button type="button" onClick={() => { onApply(s.snapshot); toast.info(`Applied "${s.name}"`); }} className="hover:underline font-medium" data-testid={`saved-filter-${s.name}`}>{s.name}</button>
          <X className="w-3 h-3 cursor-pointer text-violet-400 hover:text-violet-700" onClick={() => persist(saved.filter((x) => x.name !== s.name))} data-testid={`saved-filter-del-${s.name}`} />
        </span>
      ))}
      <button type="button" onClick={save} className="text-[11px] px-2 py-0.5 rounded-full border border-dashed border-slate-300 text-slate-500 hover:bg-slate-50 flex items-center gap-1" data-testid="save-filter-btn"><Plus className="w-3 h-3" />Save current</button>
    </div>
  );
}

export function SpFilter({ all, state, setState, label = 'Salesperson', testId = 'sp-filter' }) {
  const [open, setOpen] = useState(false);
  const toggle = (name) => setState({ ...state, selected: state.selected.includes(name) ? state.selected.filter((n) => n !== name) : [...state.selected, name] });
  const active = state.selected.length > 0;
  return (
    <span className="relative inline-block">
      <button type="button" onClick={() => setOpen(!open)} data-testid={`${testId}-btn`}
        className={`text-[11px] px-2.5 py-1 rounded-md border transition ${active ? 'bg-violet-50 border-violet-300 text-violet-700 font-medium' : 'bg-white border-slate-200 text-slate-600 hover:bg-slate-50'}`}>
        {label}{active ? ` · ${state.op === 'is not in' ? 'excluding' : 'only'} ${state.selected.length}` : ''} ▾
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute z-50 mt-1 w-60 bg-white border border-slate-200 rounded-lg shadow-lg p-2" data-testid={`${testId}-popover`}>
            <div className="flex gap-1 mb-2">
              {[['is in', 'Include only'], ['is not in', 'Exclude']].map(([op, lbl]) => (
                <button key={op} type="button" onClick={() => setState({ ...state, op })} data-testid={`${testId}-op-${op === 'is in' ? 'include' : 'exclude'}`}
                  className={`flex-1 text-[11px] px-2 py-1 rounded-md border ${state.op === op ? 'bg-violet-600 text-white border-violet-600' : 'bg-white border-slate-200 text-slate-600'}`}>{lbl}</button>
              ))}
            </div>
            <div className="max-h-52 overflow-y-auto space-y-0.5">
              {all.map((n) => (
                <label key={n} className="flex items-center gap-2 text-xs px-1 py-1 rounded hover:bg-slate-50 cursor-pointer">
                  <input type="checkbox" checked={state.selected.includes(n)} onChange={() => toggle(n)} data-testid={`${testId}-check-${n}`} />
                  <span className="truncate">{n}</span>
                </label>
              ))}
            </div>
            <button type="button" onClick={() => setState({ op: 'is in', selected: [] })} className="text-[11px] text-slate-500 hover:text-slate-800 mt-2" data-testid={`${testId}-clear`}>Clear</button>
          </div>
        </>
      )}
    </span>
  );
}
